// Timeline.js
import React, { useState, useEffect } from "react";
import drawerTemplate from "../../hoc/drawerTemplate";
import ProjectService from "../../api/projectService";
import TopHeader from "./Components/TopHeader";
import TimelineComponent from "./Components/TimelineComponents/TimelineComponent";
import ChatComponent from "./Components/ChatComponent";
import LoadingComponent from "../../components/LoadingComponent";
import getProjectData from "./Helpers/getProjects";
import NoTimelineData from "./Components/TimelineComponents/NoTimelineData";

import { RxCross2 } from "react-icons/rx";
import { FiMessageCircle } from "react-icons/fi";
import { RiSendPlaneFill } from "react-icons/ri";
const Timeline = () => {
  
  const projectService = new ProjectService();

  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedTab, setSelectedTab] = useState("BOQ timeline");
  const [searchQuery, setSearchQuery] = useState("");
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(false);
  // Chat functionality state
  const [isChatVisible, setIsChatVisible] = useState(false);
  const [chatHeight, setChatHeight] = useState(40); // Track chat height percentage

  // Fetch all available projects initially
  const fetchProjects = async () => {
    try {
      const res = await projectService.getProjects();
      if (res?.payload) {
        setProjects(res.payload);
      }
    } catch (error) {
      console.error("Failed to fetch projects:", error);
    }
  };

  const fetchProjectData = async (project) => {
    if (!project) return;

    setLoading(true);

    try {
      // const res = await getProjectData(project); // replace with actual method
      // if (res && res.length > 0) {
        // setProjectData(res);
      // } else {
      //   setProjectData(null);
      // }

      setProjectData([
        {
          serialNumber: "1",
          category: "Planning",
          taskName: "Site Preparation & Planning",
          startDate: "2025-05-01",
          endDate: "2025-05-07",
          progress: "100",
          predecessor: [],
          successor: ["2"],
          department: "Management",
          assignedTo: ["Project Manager", "Architect"],
          estimatedDelay: "0",
          currentIndex: 0,
          subTasks: [
            {
              serialNumber: "1.1",
              category: "Planning",
              taskName: "Site Survey & Soil Test",
              startDate: "2025-05-01",
              endDate: "2025-05-02",
              progress: "100",
              predecessor: [],
              successor: [],
              department: "Civil",
              assignedTo: ["Surveyor"],
              estimatedDelay: "0",
              currentIndex: 0,
            },
            {
              serialNumber: "1.2",
              category: "Planning",
              taskName: "Architectural Design Approval",
              startDate: "2025-05-03",
              endDate: "2025-05-05",
              progress: "100",
              predecessor: ["1.1"],
              successor: [],
              department: "Architecture",
              assignedTo: ["Architect"],
              estimatedDelay: "0",
              currentIndex: 1,
            },
            {
              serialNumber: "1.3",
              category: "Planning",
              taskName: "Material Procurement Plan",
              startDate: "2025-05-06",
              endDate: "2025-05-07",
              progress: "100",
              predecessor: ["1.2"],
              successor: [],
              department: "Procurement",
              assignedTo: ["Procurement Officer"],
              estimatedDelay: "0",
              currentIndex: 2,
            },
          ],
        },
        {
          serialNumber: "2",
          category: "Execution",
          taskName: "Excavation & Foundation",
          startDate: "2025-05-08",
          endDate: "2025-05-20",
          progress: "100",
          predecessor: ["1"],
          successor: ["3"],
          department: "Civil",
          assignedTo: ["Site Engineer"],
          estimatedDelay: "0",
          currentIndex: 1,
          subTasks: [
            {
              serialNumber: "2.1",
              category: "Execution",
              taskName: "Site Clearing & Excavation",
              startDate: "2025-05-08",
              endDate: "2025-05-10",
              progress: "100",
              predecessor: [],
              successor: [],
              department: "Civil",
              assignedTo: ["Labour Contractor"],
              estimatedDelay: "0",
              currentIndex: 0,
            },
            {
              serialNumber: "2.2",
              category: "Execution",
              taskName: "Footing Layout & PCC",
              startDate: "2025-05-11",
              endDate: "2025-05-13",
              progress: "100",
              predecessor: ["2.1"],
              successor: [],
              department: "Civil",
              assignedTo: ["Site Engineer"],
              estimatedDelay: "0",
              currentIndex: 1,
            },
            {
              serialNumber: "2.3",
              category: "Execution",
              taskName: "Footing Reinforcement & Concrete",
              startDate: "2025-05-14",
              endDate: "2025-05-17",
              progress: "100",
              predecessor: ["2.2"],
              successor: [],
              department: "Civil",
              assignedTo: ["Steel Contractor"],
              estimatedDelay: "0",
              currentIndex: 2,
            },
            {
              serialNumber: "2.4",
              category: "Execution",
              taskName: "Plinth Beam & Backfilling",
              startDate: "2025-05-18",
              endDate: "2025-05-20",
              progress: "100",
              predecessor: ["2.3"],
              successor: [],
              department: "Civil",
              assignedTo: ["Mason"],
              estimatedDelay: "0",
              currentIndex: 3,
            },
          ],
        },
        {
          serialNumber: "3",
          category: "Execution",
          taskName: "Superstructure - Ground Floor",
          startDate: "2025-05-21",
          endDate: "2025-06-05",
          progress: "80",
          predecessor: ["2"],
          successor: ["4"],
          department: "Civil",
          assignedTo: ["Mason", "Steel Worker"],
          estimatedDelay: "2",
          currentIndex: 2,
          subTasks: [
            {
              serialNumber: "3.1",
              category: "Execution",
              taskName: "Column Casting - GF",
              startDate: "2025-05-21",
              endDate: "2025-05-25",
              progress: "100",
              predecessor: [],
              successor: [],
              department: "Civil",
              assignedTo: ["Steel Worker"],
              estimatedDelay: "0",
              currentIndex: 0,
            },
            {
              serialNumber: "3.2",
              category: "Execution",
              taskName: "Slab Shuttering & Reinforcement",
              startDate: "2025-05-26",
              endDate: "2025-05-30",
              progress: "60",
              predecessor: ["3.1"],
              successor: [],
              department: "Civil",
              assignedTo: ["Carpenter"],
              estimatedDelay: "1",
              currentIndex: 1,
            },
            {
              serialNumber: "3.3",
              category: "Execution",
              taskName: "Slab Concrete & Curing",
              startDate: "2025-05-31",
              endDate: "2025-06-05",
              progress: "50",
              predecessor: ["3.2"],
              successor: [],
              department: "Civil",
              assignedTo: ["Concrete Contractor"],
              estimatedDelay: "1",
              currentIndex: 2,
            },
          ],
        },
        {
          serialNumber: "4",
          category: "Execution",
          taskName: "Superstructure - First Floor",
          startDate: "2025-06-06",
          endDate: "2025-06-20",
          progress: "0",
          predecessor: ["3"],
          successor: ["5"],
          department: "Civil",
          assignedTo: ["Mason"],
          estimatedDelay: "0",
          currentIndex: 3,
          subTasks: [
            {
              serialNumber: "4.1",
              category: "Execution",
              taskName: "Column Casting - FF",
              startDate: "2025-06-06",
              endDate: "2025-06-09",
              progress: "0",
              predecessor: [],
              successor: [],
              department: "Civil",
              assignedTo: ["Steel Worker"],
              estimatedDelay: "0",
              currentIndex: 0,
            },
            {
              serialNumber: "4.2",
              category: "Execution",
              taskName: "Slab Shuttering & Concrete",
              startDate: "2025-06-10",
              endDate: "2025-06-20",
              progress: "0",
              predecessor: ["4.1"],
              successor: [],
              department: "Civil",
              assignedTo: ["Carpenter", "Concrete Contractor"],
              estimatedDelay: "0",
              currentIndex: 1,
            },
          ],
        },
        {
          serialNumber: "5",
          category: "Material Purchase",
          taskName: "Key Material Procurement",
          startDate: "2025-05-01",
          endDate: "2025-06-10",
          progress: "50",
          predecessor: ["1"],
          successor: ["6"],
          department: "Procurement",
          assignedTo: ["Procurement Officer"],
          estimatedDelay: "1",
          currentIndex: 4,
          subTasks: [
            {
              serialNumber: "5.1",
              category: "Material Purchase",
              taskName: "Cement, Steel & Sand",
              startDate: "2025-05-01",
              endDate: "2025-05-10",
              progress: "100",
              predecessor: [],
              successor: [],
              department: "Procurement",
              assignedTo: ["Vendor A"],
              estimatedDelay: "0",
              currentIndex: 0,
            },
            {
              serialNumber: "5.2",
              category: "Material Purchase",
              taskName: "Bricks & Blocks",
              startDate: "2025-05-15",
              endDate: "2025-05-20",
              progress: "100",
              predecessor: [],
              successor: [],
              department: "Procurement",
              assignedTo: ["Vendor B"],
              estimatedDelay: "0",
              currentIndex: 1,
            },
            {
              serialNumber: "5.3",
              category: "Material Purchase",
              taskName: "Electrical & Plumbing Fixtures",
              startDate: "2025-06-01",
              endDate: "2025-06-10",
              progress: "0",
              predecessor: [],
              successor: [],
              department: "Procurement",
              assignedTo: ["Vendor C"],
              estimatedDelay: "1",
              currentIndex: 2,
            },
          ],
        },
        {
          serialNumber: "6",
          category: "MEP",
          taskName: "Electrical & Plumbing Works",
          startDate: "2025-06-21",
          endDate: "2025-07-10",
          progress: "0",
          predecessor: ["4", "5"],
          successor: ["7"],
          department: "MEP",
          assignedTo: ["Plumber", "Electrician"],
          estimatedDelay: "0",
          currentIndex: 5,
          subTasks: [
            {
              serialNumber: "6.1",
              category: "MEP",
              taskName: "Concealed Piping & Wiring",
              startDate: "2025-06-21",
              endDate: "2025-06-30",
              progress: "0",
              predecessor: [],
              successor: [],
              department: "MEP",
              assignedTo: ["Plumber", "Electrician"],
              estimatedDelay: "0",
              currentIndex: 0,
            },
            {
              serialNumber: "6.2",
              category: "MEP",
              taskName: "Fixtures & Testing",
              startDate: "2025-07-01",
              endDate: "2025-07-10",
              progress: "0",
              predecessor: ["6.1"],
              successor: [],
              department: "MEP",
              assignedTo: ["Electrician"],
              estimatedDelay: "0",
              currentIndex: 1,
            },
          ],
        },
        {
          serialNumber: "7",
          category: "Finishing",
          taskName: "Plaster, Flooring & Painting",
          startDate: "2025-07-11",
          endDate: "2025-08-01",
          progress: "0",
          predecessor: ["6"],
          successor: [],
          department: "Interior",
          assignedTo: ["Painter", "Tiler"],
          estimatedDelay: "0",
          currentIndex: 6,
          subTasks: [
            {
              serialNumber: "7.1",
              category: "Finishing",
              taskName: "Wall Plaster & Waterproofing",
              startDate: "2025-07-11",
              endDate: "2025-07-17",
              progress: "0",
              predecessor: [],
              successor: [],
              department: "Civil",
              assignedTo: ["Plaster Contractor"],
              estimatedDelay: "0",
              currentIndex: 0,
            },
            {
              serialNumber: "7.2",
              category: "Finishing",
              taskName: "Tile & Marble Work",
              startDate: "2025-07-18",
              endDate: "2025-07-25",
              progress: "0",
              predecessor: ["7.1"],
              successor: [],
              department: "Interior",
              assignedTo: ["Tiler"],
              estimatedDelay: "0",
              currentIndex: 1,
            },
            {
              serialNumber: "7.3",
              category: "Finishing",
              taskName: "Interior & Exterior Paint",
              startDate: "2025-07-26",
              endDate: "2025-08-01",
              progress: "0",
              predecessor: ["7.2"],
              successor: [],
              department: "Interior",
              assignedTo: ["Painter"],
              estimatedDelay: "0",
              currentIndex: 2,
            },
          ],
        },
        {
          serialNumber: "7",
          category: "Execution",
          taskName: "Wall Construction & Plastering",
          startDate: "2025-07-11",
          endDate: "2025-07-25",
          progress: "0",
          predecessor: ["6"],
          successor: ["8"],
          department: "Civil",
          assignedTo: ["Mason"],
          estimatedDelay: "0",
          currentIndex: 6,
          subTasks: [
            {
              serialNumber: "7.1",
              category: "Execution",
              taskName: "Masonry Work - GF & FF",
              startDate: "2025-07-11",
              endDate: "2025-07-18",
              progress: "0",
              predecessor: [],
              successor: [],
              department: "Civil",
              assignedTo: ["Mason"],
              estimatedDelay: "0",
              currentIndex: 0,
            },
            {
              serialNumber: "7.2",
              category: "Execution",
              taskName: "Internal & External Plaster",
              startDate: "2025-07-19",
              endDate: "2025-07-25",
              progress: "0",
              predecessor: ["7.1"],
              successor: [],
              department: "Civil",
              assignedTo: ["Plastering Team"],
              estimatedDelay: "0",
              currentIndex: 1,
            }
          ]
        },
        {
          serialNumber: "8",
          category: "Finishing",
          taskName: "Flooring Works",
          startDate: "2025-07-26",
          endDate: "2025-08-05",
          progress: "0",
          predecessor: ["7"],
          successor: ["9"],
          department: "Interior",
          assignedTo: ["Tiling Contractor"],
          estimatedDelay: "0",
          currentIndex: 7,
          subTasks: [
            {
              serialNumber: "8.1",
              category: "Finishing",
              taskName: "Tile Laying - Bathrooms",
              startDate: "2025-07-26",
              endDate: "2025-07-29",
              progress: "0",
              predecessor: [],
              successor: [],
              department: "Interior",
              assignedTo: ["Tiling Contractor"],
              estimatedDelay: "0",
              currentIndex: 0,
            },
            {
              serialNumber: "8.2",
              category: "Finishing",
              taskName: "Tile Laying - Rooms",
              startDate: "2025-07-30",
              endDate: "2025-08-05",
              progress: "0",
              predecessor: ["8.1"],
              successor: [],
              department: "Interior",
              assignedTo: ["Tiling Contractor"],
              estimatedDelay: "0",
              currentIndex: 1,
            }
          ]
        },
        {
          serialNumber: "9",
          category: "Execution",
          taskName: "Painting & Texturing",
          startDate: "2025-08-06",
          endDate: "2025-08-15",
          progress: "0",
          predecessor: ["8"],
          successor: ["10"],
          department: "Interior",
          assignedTo: ["Painter"],
          estimatedDelay: "0",
          currentIndex: 8,
          subTasks: [
            {
              serialNumber: "9.1",
              category: "Execution",
              taskName: "Primer & Wall Putty",
              startDate: "2025-08-06",
              endDate: "2025-08-10",
              progress: "0",
              predecessor: [],
              successor: [],
              department: "Interior",
              assignedTo: ["Painter"],
              estimatedDelay: "0",
              currentIndex: 0,
            },
            {
              serialNumber: "9.2",
              category: "Execution",
              taskName: "Final Paint Finish",
              startDate: "2025-08-11",
              endDate: "2025-08-15",
              progress: "0",
              predecessor: ["9.1"],
              successor: [],
              department: "Interior",
              assignedTo: ["Painter"],
              estimatedDelay: "0",
              currentIndex: 1,
            }
          ]
        },
        {
          serialNumber: "10",
          category: "MEP",
          taskName: "Electrical & Plumbing Fixtures Installation",
          startDate: "2025-08-16",
          endDate: "2025-08-22",
          progress: "0",
          predecessor: ["9"],
          successor: ["11"],
          department: "MEP",
          assignedTo: ["Plumber", "Electrician"],
          estimatedDelay: "0",
          currentIndex: 9,
          subTasks: [
            {
              serialNumber: "10.1",
              category: "MEP",
              taskName: "Sanitary Fittings",
              startDate: "2025-08-16",
              endDate: "2025-08-18",
              progress: "0",
              predecessor: [],
              successor: [],
              department: "MEP",
              assignedTo: ["Plumber"],
              estimatedDelay: "0",
              currentIndex: 0,
            },
            {
              serialNumber: "10.2",
              category: "MEP",
              taskName: "Switchboard & Fixtures",
              startDate: "2025-08-19",
              endDate: "2025-08-22",
              progress: "0",
              predecessor: ["10.1"],
              successor: [],
              department: "MEP",
              assignedTo: ["Electrician"],
              estimatedDelay: "0",
              currentIndex: 1,
            }
          ]
        },
        {
          serialNumber: "11",
          category: "Finishing",
          taskName: "Interior Woodwork & Carpentry",
          startDate: "2025-08-23",
          endDate: "2025-09-05",
          progress: "0",
          predecessor: ["10"],
          successor: ["12"],
          department: "Interior",
          assignedTo: ["Carpenter"],
          estimatedDelay: "0",
          currentIndex: 10,
          subTasks: [
            {
              serialNumber: "11.1",
              category: "Finishing",
              taskName: "Wardrobe Installation",
              startDate: "2025-08-23",
              endDate: "2025-08-28",
              progress: "0",
              predecessor: [],
              successor: [],
              department: "Interior",
              assignedTo: ["Carpenter"],
              estimatedDelay: "0",
              currentIndex: 0
            },
            {
              serialNumber: "11.2",
              category: "Finishing",
              taskName: "Modular Kitchen Setup",
              startDate: "2025-08-29",
              endDate: "2025-09-05",
              progress: "0",
              predecessor: ["11.1"],
              successor: [],
              department: "Interior",
              assignedTo: ["Carpenter"],
              estimatedDelay: "0",
              currentIndex: 1
            }
          ]
        },
        {
          serialNumber: "12",
          category: "Finishing",
          taskName: "Doors and Windows Fitting",
          startDate: "2025-09-06",
          endDate: "2025-09-12",
          progress: "0",
          predecessor: ["11"],
          successor: ["13"],
          department: "Civil",
          assignedTo: ["Carpenter"],
          estimatedDelay: "0",
          currentIndex: 11,
          subTasks: [
            {
              serialNumber: "12.1",
              category: "Finishing",
              taskName: "Main & Room Doors Fixing",
              startDate: "2025-09-06",
              endDate: "2025-09-09",
              progress: "0",
              predecessor: [],
              successor: [],
              department: "Civil",
              assignedTo: ["Carpenter"],
              estimatedDelay: "0",
              currentIndex: 0
            },
            {
              serialNumber: "12.2",
              category: "Finishing",
              taskName: "Window Glass & Frames",
              startDate: "2025-09-10",
              endDate: "2025-09-12",
              progress: "0",
              predecessor: ["12.1"],
              successor: [],
              department: "Civil",
              assignedTo: ["Carpenter"],
              estimatedDelay: "0",
              currentIndex: 1
            }
          ]
        },
        {
          serialNumber: "13",
          category: "External Works",
          taskName: "Compound Wall & Gate Installation",
          startDate: "2025-09-13",
          endDate: "2025-09-20",
          progress: "0",
          predecessor: ["12"],
          successor: ["14"],
          department: "Civil",
          assignedTo: ["Mason", "Welder"],
          estimatedDelay: "0",
          currentIndex: 12,
          subTasks: [
            {
              serialNumber: "13.1",
              category: "External Works",
              taskName: "Compound Wall Masonry",
              startDate: "2025-09-13",
              endDate: "2025-09-17",
              progress: "0",
              predecessor: [],
              successor: [],
              department: "Civil",
              assignedTo: ["Mason"],
              estimatedDelay: "0",
              currentIndex: 0
            },
            {
              serialNumber: "13.2",
              category: "External Works",
              taskName: "Gate Fabrication & Installation",
              startDate: "2025-09-18",
              endDate: "2025-09-20",
              progress: "0",
              predecessor: ["13.1"],
              successor: [],
              department: "Civil",
              assignedTo: ["Welder"],
              estimatedDelay: "0",
              currentIndex: 1
            }
          ]
        },
        {
          serialNumber: "14",
          category: "Finishing",
          taskName: "External Painting",
          startDate: "2025-09-21",
          endDate: "2025-09-25",
          progress: "0",
          predecessor: ["13"],
          successor: ["15"],
          department: "Painting",
          assignedTo: ["Painter"],
          estimatedDelay: "0",
          currentIndex: 13,
          subTasks: [
            {
              serialNumber: "14.1",
              category: "Finishing",
              taskName: "Wall Primer & Texture",
              startDate: "2025-09-21",
              endDate: "2025-09-23",
              progress: "0",
              predecessor: [],
              successor: [],
              department: "Painting",
              assignedTo: ["Painter"],
              estimatedDelay: "0",
              currentIndex: 0
            },
            {
              serialNumber: "14.2",
              category: "Finishing",
              taskName: "Final Coat",
              startDate: "2025-09-24",
              endDate: "2025-09-25",
              progress: "0",
              predecessor: ["14.1"],
              successor: [],
              department: "Painting",
              assignedTo: ["Painter"],
              estimatedDelay: "0",
              currentIndex: 1
            }
          ]
        },
        {
          serialNumber: "15",
          category: "Handover",
          taskName: "Final Cleaning & Handover",
          startDate: "2025-09-26",
          endDate: "2025-09-30",
          progress: "0",
          predecessor: ["14"],
          successor: [],
          department: "Management",
          assignedTo: ["Supervisor"],
          estimatedDelay: "0",
          currentIndex: 14,
          subTasks: [
            {
              serialNumber: "15.1",
              category: "Handover",
              taskName: "Site Cleaning & Debris Removal",
              startDate: "2025-09-26",
              endDate: "2025-09-28",
              progress: "0",
              predecessor: [],
              successor: [],
              department: "Management",
              assignedTo: ["Cleaning Crew"],
              estimatedDelay: "0",
              currentIndex: 0
            },
            {
              serialNumber: "15.2",
              category: "Handover",
              taskName: "Snag List Resolution & Key Handover",
              startDate: "2025-09-29",
              endDate: "2025-09-30",
              progress: "0",
              predecessor: ["15.1"],
              successor: [],
              department: "Management",
              assignedTo: ["Supervisor"],
              estimatedDelay: "0",
              currentIndex: 1
            }
          ]
        }
      ]);
      
    } catch (error) {
      console.error("Failed to fetch project data:", error);
      setProjectData(null);
    } finally {
      setLoading(false);
    }
  };

  // Chat toggle functionality
  const handleChatToggle = () => {
    setIsChatVisible(!isChatVisible);
  };

  // Add task functionality
  const handleAddTask = () => {
    if (!projectData) return;
    
    console.log("Add Task clicked");

    const newTask = {
      serialNumber: `${projectData.length + 1}`,
      category: "Tap to enter",
      taskName: "Tap to enter",
      startDate: "",
      endDate: "",
      progress: "0",
      predecessor: [],
      successor: [],
      department: "",
      assignedTo: [],
      estimatedDelay: "0",
      currentIndex: projectData.length,
      subTasks: []
    };

    // Append the new task
    const updatedData = [...projectData, newTask];
    setProjectData(updatedData);
  };

  // Trigger project data fetch on project change
  useEffect(() => {
    if (selectedProject) {
      fetchProjectData(selectedProject);
    } else {
      setProjectData(null);
    }
  }, [selectedProject]);

  // Initial load for project list
  useEffect(() => {
    fetchProjects();
  }, []);

  return (
    <div style={styles.wrapper}>
      <div style={styles.topHeader}>
        <TopHeader
          projects={projects}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onAddTask={handleAddTask}
        />
      </div>

      <div style={{
        ...styles.content,
        height: isChatVisible ? `calc(${100 - chatHeight}vh - 76px)` : "calc(100vh - 76px)",
        transition: "height 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      }}>
        {loading ? (
          <LoadingComponent progressState={0} />
        ) : projectData === null ? (
          <NoTimelineData />
        ) : (
          <TimelineComponent 
            data={projectData} 
            setProjectData={setProjectData} 
            selectedTab={selectedTab} 
            onChatToggle={handleChatToggle}
            searchQuery={searchQuery}
          />
        )}
      </div>

      {/* Chat Component */}
      <ChatComponent 
        isVisible={isChatVisible}
        onClose={handleChatToggle}
        selectedTab={selectedTab}
        chatHeight={chatHeight}
        setChatHeight={setChatHeight}
      />
    </div>
  );
};

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    overflow: "hidden",
    background: "linear-gradient(135deg, #ece9e6, #ffffff)",
    position: "relative",
  },
  topHeader: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: "#fff",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  content: {
    overflowY: "auto",
    padding: "0.5rem",
    display: "flex",
    flexDirection: "column",
  },
};

export default drawerTemplate(Timeline);